import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ROOT_REDUCER_KEYS, PROXY_STATUS_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceProxyStatusUpdatePrefix = 'workspaceProxyStatusUpdate';
const workspaceProxyStatusUpdateEpicReducerArg = {
    actionPrefix: workspaceProxyStatusUpdatePrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.PROXY_STATUS,
        PROXY_STATUS_ACTION_KEYS.PUT,
    ],
    loadResource: (request) => WPSResource.updateWorkspaceProxyStatus(request),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceProxyStatusUpdateEpicReducer = loadResourcesUtils(workspaceProxyStatusUpdateEpicReducerArg);

//# sourceMappingURL=UpdateWorkspaceProxyStatus.ducks.js.map
